import { ProjectTabDto } from '../api_client/parameter_api';

export const getUpdatedLocalTabIds = (projectSlug: string, updatedTab: ProjectTabDto): Array<number> => {
  const localTabHiddenIds = localStorage.getItem(projectSlug);
  let updatedLocalTabIds: Array<number> = [];
  if (localTabHiddenIds) {
    const parsedLocalTabIds = JSON.parse(localTabHiddenIds);
    if (updatedTab.hidden) {
      updatedLocalTabIds = [...parsedLocalTabIds, updatedTab.id];
    } else {
      updatedLocalTabIds = parsedLocalTabIds.filter((id: number) => id !== updatedTab.id);
    }
  } else {
    if (updatedTab.hidden) {
      updatedLocalTabIds.push(updatedTab.id as number);
    }
  }
  if (!!updatedLocalTabIds.length) {
    localStorage.setItem(projectSlug, JSON.stringify(updatedLocalTabIds));
  } else {
    localStorage.removeItem(projectSlug);
  }

  return updatedLocalTabIds;
};
